import React from "react";
import { useAuthStore } from "../../stores/authStore";

interface SignedInProps {
  children: React.ReactNode;
  fallback: React.ReactNode;
}

export const SignedIn: React.FC<SignedInProps> = ({ children, fallback }) => {
  const { accessToken } = useAuthStore();
  return accessToken ? <>{children}</> : <>{fallback}</>;
};
